var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tabs',{attrs:{"vertical":""}},[_c('v-tab',[_vm._v("Weekly Usage")]),_c('v-tab-item')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }